import ERROR_MAP from './errorMap.json'
import { LANG } from '../language/lang'

export function MapError(module, code) {
    const safeCode = typeof code === 'string'
        ? code
        : code?.code ?? code?.message ?? 'UNEXPECTED_ERROR'

    const mappedError =
        ERROR_MAP[module]?.[safeCode] || ERROR_MAP['UNEXPECTED_ERROR'] || {}

    return {
        field: mappedError.field || ['global'],
        message: LANG(mappedError.text || 'ERROR_TEXT_UNEXPECTED_ERROR'),
        severity: mappedError.severity || 'error',
        showInUI: mappedError.showInUI !== false
    }
}